import { defineComponent as l, openBlock as e, createElementBlock as o, normalizeClass as c, toDisplayString as n, createCommentVNode as a, createElementVNode as r } from "vue";
const m = { key: 0 }, k = /* @__PURE__ */ l({
  name: "toast-content",
  __name: "toast-content",
  props: {
    title: {},
    message: {},
    buttonText: {}
  },
  emits: ["toast-action-clicked"],
  setup(u, { emit: s }) {
    function i() {
      s("toast-action-clicked");
    }
    return (t, p) => (e(), o("aside", {
      class: c(t.$options.name)
    }, [
      t.title ? (e(), o("h3", m, n(t.title), 1)) : a("", !0),
      r("p", null, n(t.message), 1),
      t.buttonText ? (e(), o("button", {
        key: 1,
        class: "toast-action",
        type: "button",
        role: "button",
        onClick: i
      }, n(t.buttonText), 1)) : a("", !0)
    ], 2));
  }
});
export {
  k as default
};
//# sourceMappingURL=toast-content.vue2.js.map
